module.exports = __webpack_public_path__ + "img/53400.d5b47ce0.jpg";